import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { KEY } from "web/components/utils/stripeKey";

import styles from "./stripeElement.scss";
const stripeElement = ({ children, transparentHeader, paddingTop }) => {
  const stripePromise = loadStripe(KEY);
  return (
    <Fragment>
      <Helmet>
        <meta name="viewport" content="width=device-width" />
      </Helmet>
      <div className="app-container">
        <div className={styles.body}>
          <Elements stripe={stripePromise}>
            <div className={`${paddingTop ? "app-body-top-padding" : ""}`}>
              {children}
            </div>
          </Elements>
        </div>
      </div>
    </Fragment>
  );
};

export default stripeElement;
